import { Span } from "@tblabs/truffle";
import { Rows } from "../../../Components/Utils/Rows";
import { AgentsProvider } from "../../../Services/AgentsProvider";
import { TimeUtils } from "../../../Utils/TimeUtils";
import { PersonalPickupStepData } from "../Models/PersonalPickupStepData";


export class MeetingInfoForCustomer extends Rows
{
    constructor(_agent: AgentsProvider, data: PersonalPickupStepData)
    {
        const agent = _agent.Get(data.AssignedAgentId.value);

        const sum = (data.BasketSum.value + data.DepositSum.value) || data.PaymentAtDelivery.value; // <--- PaymentAtDelivery is legacy
        const deposit = data.DepositSum.value;

        super([
            new Span(`🕓 Pora spotkania: ${TimeUtils.FormattedDayHour(data.PlannedDispatchTime)}`).Attribute("data-testid", "meeting-time")
                .When(data.PlannedDispatchTime, v => TimeUtils.IsHourSet(v), _ => _.Background("none"), _ => _.Background("#ffe5e5")),
            new Span(`🗺️ Miejsce odbioru: ${data.MeetingPlace.value || "jeszcze nie ustalone"}`).Attribute("data-testid", "meeting-place"),
            new Span(`👤 ${agent
                ? `Spotkanie z: ${agent.Name}, tel. ${agent.Phone}`
                : "Opiekun jeszcze nie przypisany"}`).Attribute("data-testid", "meeting-agent")
                .When(data.AssignedAgentId, v => !!v, _ => _.Background("none"), _ => _.Background("#ffe5e5")),
            new Span(sum > 0
                ? `💰 Płatność: ${sum} zł (w tym ${deposit} zł kaucji), płatne tylko gotówką`
                : `💰 Zamówienie jest już opłacone`).Attribute("data-testid", "meeting-payment"),
            new Span(data.Training.value
                ? `🎓 Szkolenie odbędzie się na miejscu`
                : `🎓 Bez szkolenia`).Attribute("data-testid", "meeting-training"),
        ]);
    }
}
